// extracted by mini-css-extract-plugin
export var MoveUpDown = "index-module--MoveUpDown--DsTNN";
export var center = "index-module--center--SVFPP";
export var fb = "index-module--fb--JymDA";
export var mainHolder = "index-module--main-holder--uJy5f";
export var photo = "index-module--photo--BZpuV";
export var photoGallery = "index-module--photo-gallery--w42+b";
export var scrollForMore = "index-module--scroll-for-more--8CCmo";
export var staticContent = "index-module--static-content--SDFqO";
export var title = "index-module--title--Vu6RA";